// Copyright (c) 2017 Deere & Company

import Dealers from '../state/labor-rates';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const updateListFiltered = (state, action) =>
    Dealers.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().dealersFiltered, action) => {

    const actionTypes = {
        [actions.UPDATE_LABOR_RATE_DEALERS_FILTERED]: updateListFiltered
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/reducers/dealers-filtered.js